import { buildDayForBooking, ProcessTypes, UserProfile } from 'fitbeat.gym-core';
import { Gym, IDay } from 'fitbeat.models';
import moment from 'moment-timezone';
import React from 'react';
import { Platform, StyleSheet, Text, View } from 'react-native';
import { connect } from 'react-redux';
import PlusIcon from '../../assets/icons/plus.svg';
import { PaywallPage } from '../../auth';
import { getNextBookingStep, setupInstantWorkout } from '../../Bookings';
import { resetWizard, scheduleOrStartWorkoutButtonPressedAction, setDayTemp } from '../../Bookings/actions';
import { Button, ButtonSize, ButtonTypes, Icon } from '../../components';
import { IAppStore } from '../../HomeWorkouts';
import { openPaywallModalAction } from '../../payments/redux/payments-actions';
import { GoogleAnalytics } from '../../services/google-analytics';
import Theme from '../../theme';
import { toggleBookingsModal } from '../../ui';
import { defaultScale, isWeb } from '../../utils';
import { clearDeepLinkParams } from '../../utils/notifications/actions';

interface IProps {
  userProfile: UserProfile;
  overrideButtonSize: any;
  buttonType: any;
  clearDeepLinkParams: any;
  toggleBookingsModal: any;
  getNextBookingStep: any;
  setupInstantWorkout: any;
  workoutSessionService: any;
  overrideButtonTextStyle: any;
  containerStyle: any;
  analyticsEvent?: string;
  resetWizard: any;
  navigation: any;
  buttonTitleOverride?: string;
  buttonContainer: any;
  buttonStyles: any;
  totalStartedWorkouts: number | null;
  openPaywallModal(): void;
  t(key: string): string;
  setDayTemp(day: IDay): void;
  scheduleOrStartWorkoutButtonPressed(): void;
}

class ScheduleWorkoutButtonComponent extends React.Component<IProps, any> {
  private googleAnalytics = new GoogleAnalytics();
  public render() {
    const { buttonTitleOverride, buttonContainer, buttonStyles, t } = this.props;
    const title = (
      <>
        <Text style={{flexDirection: 'row'}}>
          <PlusIcon width={16} height={16} />
          <View style={styles.buttonDivider}></View>
          {t('dashboard:startOrScheduleWorkout')}
        </Text>
      </>
    );

    return (
      <View style={buttonContainer}>
        <Button
          containerStyle={buttonStyles}
          title={buttonTitleOverride || title}
          size={ButtonSize.MEDIUM}
          buttonType={this.props.buttonType || ButtonTypes.NORMAL}
          isLoading={false}
          onPress={this.showBookingProcess}
          overrideFontStyles={{ ...Theme.textStyle.heading2,
            color: Theme.WHITE,
            fontWeight: '700',
            ...this.props.overrideButtonTextStyle,
          }}
        />
      </View>
    );
  }

  private showBookingProcess = () => {
    // Need to combine this with instant booking, combine dispatches into single actions
    if (this.props.analyticsEvent) {
      this.googleAnalytics.logEventWithParamaters(this.props.analyticsEvent);
    }
    const { userProfile, totalStartedWorkouts } = this.props;
    const isFirstWorkout = totalStartedWorkouts === 0;

    if (!UserProfile.hasActivePlan(userProfile)) {
      this.props.openPaywallModal();
      this.props.clearDeepLinkParams([ 'workoutInviteStartTime' ]);
      return;
    }
    this.props.resetWizard(userProfile);
    this.props.scheduleOrStartWorkoutButtonPressed();
    this.props.toggleBookingsModal(false);
    const day = buildDayForBooking(moment(), true);
    this.props.setDayTemp(day);
    this.props.getNextBookingStep(userProfile, ProcessTypes.Start, isFirstWorkout);
    this.props.toggleBookingsModal(true);
  }
}

const styles = StyleSheet.create({
  buttonDivider: {
    width: defaultScale(10),
  },
});

function mapStateToProps(state: IAppStore): Partial<IProps> {
  return {
    totalStartedWorkouts: state.summaryDashboard.data.totalStartedWorkouts,
  };
}

const mapDispatchToProps = (dispatch: any): Partial<IProps> => {
  return {
    getNextBookingStep: (userProfile, processType, isFirstWorkout) =>
      dispatch(getNextBookingStep(userProfile, processType, undefined, undefined, undefined, isFirstWorkout)),
    clearDeepLinkParams: (params: string[]) => dispatch(clearDeepLinkParams(params)),
    toggleBookingsModal: (visible: boolean) => dispatch(toggleBookingsModal(visible)),
    setupInstantWorkout: (gymName: string, day: any) => dispatch(setupInstantWorkout(gymName, day)),
    setDayTemp: (day: IDay) => dispatch(setDayTemp(day)),
    resetWizard: (userProfile) => dispatch(resetWizard(userProfile)),
    scheduleOrStartWorkoutButtonPressed: () => dispatch(scheduleOrStartWorkoutButtonPressedAction),
    openPaywallModal: () => dispatch(openPaywallModalAction(PaywallPage.Workout)),
  };
};

export const ScheduleWorkoutButton = connect(
  mapStateToProps, mapDispatchToProps)(ScheduleWorkoutButtonComponent);
